import { render, staticRenderFns } from "./Gruppo.vue?vue&type=template&id=0d8618ad&scoped=true&"
import script from "./Gruppo.vue?vue&type=script&lang=js&"
export * from "./Gruppo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8618ad",
  null
  
)

export default component.exports